let faults = [
  {
    key: "Mechanical Unbalance Condition",
    faults: "Mechanical Unbalance Condition",
    assets: [
      "INDUCTION_MOTOR",
      "SYNCHRONOUS_MOTOR",
      "ALTERNATOR",
      "DC_MOTOR",
      "GEAR",
      "PUMP",
      "COMPRESSOR",
      "FAN_BLOWER",
      "JOURNAL_BEARING",
    ],
    faultGroup: "Mechanical",
  },
  {
    key: "Possible Early Stage Bearing Issue - Ball Spin anomaly is detected",
    faults: "Ball Spin Anomaly ",
    assets: ["PUMP"],
    faultGroup: "Mechanical",
  },
  {
    faults: "Soft Foot Condition",
    key: "Soft Foot Condition",
    assets: [
      "INDUCTION_MOTOR",
      "SYNCHRONOUS_MOTOR",
      "ALTERNATOR",
      "DC_MOTOR",
      "GEAR",
      "PUMP",
      "COMPRESSOR",
      "FAN_BLOWER",
      "JOURNAL_BEARING",
    ],
    faultGroup: "Mechanical",
  },
  {
    key: "Looseness Condition",
    faults: "Looseness Condition",
    assets: [
      "INDUCTION_MOTOR",
      "SYNCHRONOUS_MOTOR",
      "ALTERNATOR",
      "DC_MOTOR",
      "GEAR",
      "PUMP",
      "COMPRESSOR",
      "FAN_BLOWER",
      "JOURNAL_BEARING",
    ],
    faultGroup: "Mechanical",
  },
  {
    key: "Parallel Misalignment Condition",
    faults: "Parallel Misalignment",
    assets: [
      "INDUCTION_MOTOR",
      "SYNCHRONOUS_MOTOR",
      "ALTERNATOR",
      "DC_MOTOR",
      "GEAR",
      "PUMP",
      "COMPRESSOR",
      "FAN_BLOWER",
      "JOURNAL_BEARING",
    ],
    faultGroup: "Mechanical",
  },
  {
    key: "Angular Misalignment",
    faults: "Angular Misalignment",
    assets: [
      "INDUCTION_MOTOR",
      "SYNCHRONOUS_MOTOR",
      "ALTERNATOR",
      "DC_MOTOR",
      "GEAR",
      "PUMP",
      "COMPRESSOR",
      "FAN_BLOWER",
      "JOURNAL_BEARING",
    ],
    faultGroup: "Mechanical",
  },
  {
    key: "Bent Shaft Condition",
    faults: "Bent Shaft",
    assets: [
      "INDUCTION_MOTOR",
      "SYNCHRONOUS_MOTOR",
      "ALTERNATOR",
      "DC_MOTOR",
      "GEAR",
      "PUMP",
      "COMPRESSOR",
      "FAN_BLOWER",
      "JOURNAL_BEARING",
    ],
    faultGroup: "Mechanical",
  },
  {
    key: "Fans and Blowers Rubbing Condition",
    faults: "Fans and Blowers Rubbing Condition",
    assets: ["FAN_BLOWER"],
    faultGroup: "Mechanical",
  },
  {
    key: "Fans and Blowers Eccentric Rotor",
    faults: "Fans and Blowers Eccentric Rotor",
    assets: ["FAN_BLOWER"],
    faultGroup: "Mechanical",
  },
  {
    key: "Fans and Blowers Flow Turbulence",
    faults: "Fans and Blowers Flow Turbulence",
    assets: ["FAN_BLOWER"],
    faultGroup: "Mechanical",
  },
  {
    key: "Aerodynamic Turbulence",
    faults: "Aerodynamic Turbulence",
    assets: ["FAN_BLOWER"],
    faultGroup: "Mechanical",
  },
  {
    key: "Compressor Rubbing Condition",
    faults: "Compressor Rubbing Condition",
    assets: ["COMPRESSOR"],
    faultGroup: "Mechanical",
  },
  {
    key: "Pumps Cavitation Condition",
    faults: "Pumps Cavitation Condition",
    assets: ["PUMP"],
    faultGroup: "Mechanical",
  },
  {
    key: "Pump Rubbing",
    faults: "Pump Rubbing",
    assets: ["PUMP"],
    faultGroup: "Mechanical",
  },
  {
    key: "Transverse Mounting Flexibility (Foundation/Mounting-structure) Issue",
    faults: "Transverse Mounting ",
    assets: [
      "INDUCTION_MOTOR",
      "SYNCHRONOUS_MOTOR",
      "ALTERNATOR",
      "DC_MOTOR",
      "GEAR",
      "PUMP",
      "COMPRESSOR",
      "FAN_BLOWER",
      "JOURNAL_BEARING",
    ],
    faultGroup: "Mechanical",
  },
  {
    key: "Electrical Fault Condition",
    faults: "Electrical Fault Condition",
    assets: ["INDUCTION_MOTOR", "SYNCHRONOUS_MOTOR", "ALTERNATOR"],
    faultGroup: "Electrical",
  },
  {
    key: "Stator Eccentricity",
    faults: "Stator Eccentricity",
    assets: ["INDUCTION_MOTOR", "SYNCHRONOUS_MOTOR", "ALTERNATOR"],
    faultGroup: "Electrical",
  },
  // {
  //   key: "Phase Problem",
  //   faults: "Phase Problem (Rotor)",
  //   assets: ["MOTOR"],
  //   faultGroup: "Electrical",
  // },
  {
    key: "Loose Rotor Bar",
    faults: "Loose Rotor Bar",
    assets: ["INDUCTION_MOTOR", "SYNCHRONOUS_MOTOR", "ALTERNATOR"],
    faultGroup: "Electrical",
  },
  {
    key: "Eccentric Rotor Bar",
    faults: "Eccentric Rotor Bar",
    assets: ["INDUCTION_MOTOR", "SYNCHRONOUS_MOTOR", "ALTERNATOR"],
    faultGroup: "Electrical ",
  },
  {
    key: "Broken Rotor Bar",
    faults: "Broken Rotor Bar",
    assets: ["INDUCTION_MOTOR", "SYNCHRONOUS_MOTOR", "ALTERNATOR"],
    faultGroup: "Electrical",
  },
  {
    key: " Inter - turn Fault",
    faults: " Inter - turn Fault",
    assets: ["INDUCTION_MOTOR", "SYNCHRONOUS_MOTOR", "ALTERNATOR"],
    faultGroup: "Electrical",
  },
  {
    key: "Electric Hum Noise",
    faults: "Electric Hum Noise",
    assets: ["INDUCTION_MOTOR", "SYNCHRONOUS_MOTOR", "ALTERNATOR"],
    faultGroup: "Electrical ",
  },
  {
    key: " Stator Overheating",
    faults: " Stator Overheating",
    assets: ["INDUCTION_MOTOR", "SYNCHRONOUS_MOTOR", "ALTERNATOR"],
    faultGroup: "Electrical",
  },
  // {
  //   key: "Electrical Rotor Conditions",
  //   faults: "Electrical Rotor Conditions",
  //   assets: ["MOTOR"],
  //   faultGroup: "Electrical",
  // },
  // {
  //   key: "Possible Mounting Structure (Excited Natural Frequency) Condition",
  //   faults: "Excited Natural Frequency Condition (rotor)",
  //   assets: ["GEAR"],
  //   faultGroup: "Electrical",
  // },
  // {
  //   key: "Possible Early Stage Bearing Condition",
  //   faults: "Possible Early Stage Bearing Condition (rotor)",
  //   assets: ["GEAR"],
  //   faultGroup: "Electrical",
  // },

  {
    key: "Belt or Pulley Misalignment",
    faults: "Belt or Pulley Misalignment",
    assets: [
      "INDUCTION_MOTOR",
      "SYNCHRONOUS_MOTOR",
      "ALTERNATOR",
      "DC_MOTOR",
      "PUMP",
      "COMPRESSOR",
      "FAN_BLOWER",
    ],
    faultGroup: "Belt System",
  },
  {
    key: "Eccentric or Unbalanced Pulley",
    faults: "Eccentric or Unbalanced Pulley",
    assets: [
      "INDUCTION_MOTOR",
      "SYNCHRONOUS_MOTOR",
      "ALTERNATOR",
      "DC_MOTOR",
      "PUMP",
      "COMPRESSOR",
      "FAN_BLOWER",
    ],
    faultGroup: "Belt System",
  },
  {
    key: "Worn - Loose or Mismatched Belts",
    faults: "Worn - Loose or Mismatched Belts",
    assets: [
      "INDUCTION_MOTOR",
      "SYNCHRONOUS_MOTOR",
      "ALTERNATOR",
      "DC_MOTOR",
      "PUMP",
      "COMPRESSOR",
      "FAN_BLOWER",
    ],
    faultGroup: "Belt System",
  },
  {
    key: " Belt Resonance",
    faults: " Belt Resonance",
    assets: [
      "INDUCTION_MOTOR",
      "SYNCHRONOUS_MOTOR",
      "ALTERNATOR",
      "DC_MOTOR",
      "PUMP",
      "COMPRESSOR",
      "FAN_BLOWER",
    ],
    faultGroup: "Belt System",
  },
  {
    key: "Possible Early Stage Bearing Issue - Outer Race anomaly is detected",
    faults: "Bearing Outer Race",
    assets: [
      "INDUCTION_MOTOR",
      "SYNCHRONOUS_MOTOR",
      "ALTERNATOR",
      "DC_MOTOR",
      "GEAR",
      "PUMP",
      "COMPRESSOR",
      "FAN_BLOWER",
    ],
    faultGroup: "Ball Bearing",
  },
  {
    key: "Bearing Inner Race",
    faults: "Bearing Inner Race",
    assets: [
      "INDUCTION_MOTOR",
      "SYNCHRONOUS_MOTOR",
      "ALTERNATOR",
      "DC_MOTOR",
      "GEAR",
      "PUMP",
      "COMPRESSOR",
      "FAN_BLOWER",
    ],
    faultGroup: "Ball Bearing",
  },
  {
    key: "Bearing Ball Defect",
    faults: "Bearing Ball Defect",
    assets: [
      "INDUCTION_MOTOR",
      "SYNCHRONOUS_MOTOR",
      "ALTERNATOR",
      "DC_MOTOR",
      "GEAR",
      "PUMP",
      "COMPRESSOR",
      "FAN_BLOWER",
    ],
    faultGroup: "Ball Bearing",
  },
  {
    key: "Bearing Ball Cage",
    faults: "Bearing Ball Cage",
    assets: [
      "INDUCTION_MOTOR",
      "SYNCHRONOUS_MOTOR",
      "ALTERNATOR",
      "DC_MOTOR",
      "GEAR",
      "PUMP",
      "COMPRESSOR",
      "FAN_BLOWER",
    ],
    faultGroup: "Ball Bearing",
  },
  {
    key: "Lack of Lubrication",
    faults: "Lack of Lubrication",
    assets: [
      "INDUCTION_MOTOR",
      "SYNCHRONOUS_MOTOR",
      "ALTERNATOR",
      "DC_MOTOR",
      "GEAR",
      "PUMP",
      "COMPRESSOR",
      "FAN_BLOWER",
      "JOURNAL_BEARING",
    ],
    faultGroup: "Ball Bearing",
  },
  // {
  //   key: "Possible Gear Anomaly",
  //   faults: "Gear Anomaly ",
  //   assets: ["Gearbox"],
  //   faultGroup: "Mechanical",
  // },
  {
    key: "Pinion Gear Eccentricity",
    faults: "Pinion Gear Eccentricity",
    assets: ["GEAR"],
    faultGroup: "Gearbox",
  },
  {
    key: "Excessive Backlash or Gear Tooth Wear",
    faults: "Excessive Backlash or Gear Tooth Wear",
    assets: ["GEAR"],
    faultGroup: "Gearbox",
  },
  {
    key: "Gear Misalignment",
    faults: "Gear Misalignment",
    assets: ["GEAR"],
    faultGroup: "Gearbox",
  },
  {
    key: "Possible Broken Tooth",
    faults: "Possible Broken Tooth",
    assets: ["GEAR"],
    faultGroup: "Gearbox",
  },
  {
    key: "Oil Whirl",
    faults: "Oil Whirl",
    assets: ["JOURNAL_BEARING"],
    faultGroup: "Journal Bearing",
  },
  {
    key: "Journal Bearing Looseness",
    faults: "Journal Bearing Looseness",
    assets: ["JOURNAL_BEARING"],
    faultGroup: "Journal Bearing",
  },
];

export default faults;
